/* unplugin-vue-components disabled */import { render } from "./monitorController.vue?vue&type=template&id=1d37b978"
import script from "./monitorController.vue?vue&type=script&lang=js"
export * from "./monitorController.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__